var beforePos = 0;
$(document).ready(function () {
	// let isMobile = window.matchMedia("only screen and (max-width: 767.9px)").matches;

	var hh = $("#mainHeader").outerHeight(true);

	$(document).resize(function () {
		hh = $("#mainHeader").outerHeight(true);
	});

	$("[data-role]").on("click", function () {
		var role = $(this).data("role");
		if (role == "close") {
			$(this).parents(".modal").removeClass("active");
		} else if (role == "lang") {
			$(this).next("ul").fadeToggle(500);
		} else {
			$(".modal[data-modal='" + role + "']").addClass("active");
		}
	});

	$("a[data-menu]").on("click", function () {
		var menu = $(this).data("menu");
		$(".spmenu.lv2[data-menu='" + menu + "']").addClass("active");
	});

	$(".spmenu.lv2 h4").on("click", function () {
		$(this).parent(".lv2").removeClass("active");
	});

	$(".modal:not(.editAddress)").on("click", function (e) {
		if (
			!(
				$(e.target).closest("div.modalBox").length ||
				$(e.target).closest("div.drawerBox").length ||
				$(e.target).closest("div.popupBox").length
			)
		) {
			$(this).removeClass("active");
		}
	});

	$('a[href^="#"]').on("click", function () {
		var href = $(this).attr("href");
		var target = $(href === "#" || href === "" ? "html" : href);
		var position = target.offset().top - hh;
		$("body,html").animate({ scrollTop: position }, 600, "swing");
		$("header").removeClass("scroll");

		return false;
	});

	$(window).scroll(function () {
		var scroll = $(window).scrollTop();
		var windowHeight = $(window).height();

		if (scroll == beforePos) {
			//IE11対策で処理を入れない
		} else if ((0 > scroll - beforePos) || (scroll <= 0)) {
			$("#mainHeader").removeClass("scroll");
		} else {
			$("#mainHeader").addClass("scroll");
		}
		beforePos = scroll; //現在のスクロール値を比較用のbeforePosに格納

		$("main section").each(function () {
			var imgPos = $(this).offset().top;
			if (scroll > imgPos - windowHeight + windowHeight / 4) {
				$(this).addClass("active");
				$(this).find("[data-anim]").addClass("active");
			}
		});
	});
});

//別ページからのアンカーリンク設定
$(window).on("load", function (e) {
	var hh = $("#mainHeader").outerHeight(true);
	$("#preloader").fadeOut(1000);
	$("main section").each(function () {
		var imgPos = $(this).offset().top;
		var scroll = $(window).scrollTop();
		var windowHeight = $(window).height();
		if (scroll > imgPos - windowHeight + windowHeight / 4) {
			$(this).addClass("active");
			$(this).find("[data-anim]").addClass("active");
		}
	});

	//アンカーリンク取得
	var hash = location.hash;
	//アンカーリンクがあった場合
	if ($(hash).length) {
		e.preventDefault();
		//アンカーリンクの位置取得
		var position = $(hash).offset().top - hh;
		//アンカーリンクの位置まで移動
		$("body,html").animate({ scrollTop: position }, 1, "swing");
	}
});
